import { useCallback, useMemo } from 'react';

import { useLocation, useNavigate, useSearchParams } from 'react-router';

import { useAppDispatch, useAppSelector } from '@/store/hooks';

import { dismissLimit } from '../state/symbolSelector.slice';
import { useSymbolPosition } from './useSymbolPosition';

export const useSymbolSelector = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const symbols = useAppSelector(state => state.symbolSelector.symbols);
  const isDashboardAppSelector = useAppSelector(
    state => state.symbolSelector.isDashboardAppSelector
  );

  const isInCatalog = useMemo(
    () =>
      location.pathname.toLowerCase().includes('/catalog') && !searchParams.get('indexInformation'),
    [location.pathname, searchParams]
  );

  const selectionKey = useMemo(
    () => symbols.map(symbol => JSON.stringify(symbol)).join('|'),
    [symbols]
  );

  const { position, handleDrag } = useSymbolPosition({
    symbolCount: symbols.length,
    isInCatalog,
    selectionKey
  });

  const handleClose = useCallback(() => {
    dispatch(dismissLimit());
  }, [dispatch]);

  return { position, handleDrag, handleClose, navigate, isInCatalog, isDashboardAppSelector };
};
